import React, { useEffect, useState, useCallback } from "react";
import {
  getAllWithdrawalTransactions,
  payWithdrawalTransaction,
} from "../../API/AdminWalletApi/AdminWalletApi";
import Wrapper from "../../components/wrapper/Wrapper";
import Heading from "../../components/text/Heading";
import SimplePagination from "../../components/Pagination/SimplePagination";
import toast from "react-hot-toast";
import DummyImage from "../../components/image/DummyImage";
import Loader from "../../components/Loader/Loader";

const WalletAdminPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [statusFilter, setStatusFilter] = useState(1); // Default: pending transactions
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch all withdrawal transactions using the imported function
  const fetchTransactions = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const data = await getAllWithdrawalTransactions({
        status: statusFilter,
        page,
        limit,
      });
      setTransactions({
        ...data,
      });
    } catch (err) {
      setError("Failed to fetch transactions. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [statusFilter, page, limit]);

  // Mark a transaction as paid using the imported function
  const handlePayTransaction = async (userId, transactionId) => {
    try {
      await payWithdrawalTransaction({
        userId,
        userWalletTransactionInfoId: transactionId,
      });
      toast.success("Transaction paid successfully!");
      fetchTransactions(); // Refresh the list after payment
    } catch (err) {
      toast.error("Failed to pay transaction. Please try again.");
      console.error(err);
    }
  };

  // Fetch transactions on component mount or when filters change
  useEffect(() => {
    fetchTransactions();
  }, [fetchTransactions]);

  return (
    <Wrapper>
      <Heading heading={"Withdrawal Transactions"} />

      {/* Filters */}
      <div className="mb-4">
        <label className="mr-2">
          Status:
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(Number(e.target.value))}
            className="ml-2 p-1 border rounded"
          >
            <option value={1}>Pending</option>
            <option value={2}>Paid</option>
          </select>
        </label>
      </div>

      {/* Error Message */}
      {error && <p className="text-red-500 mb-4">{error}</p>}
      {/* Transactions Table */}
      <div className="overflow-x-auto">
        {!loading ? (
          <table className="bg-white rounded-lg overflow-x-auto py-3 w-full text-[12px]">
            <thead>
              <tr>
                <th className="border-b border-gray-300 px-4 py-2 text-center">
                  User
                </th>
                <th className="border-b border-gray-300 px-4 py-2 text-center">
                  Amount
                </th>
                <th className="border-b border-gray-300 px-4 py-2 text-center">
                  Status
                </th>
                <th className="border-b border-gray-300 px-4 py-2 text-center">
                  Date
                </th>
                <th className="border-b border-gray-300 px-4 py-2 text-center">
                  Account
                </th>
                <th className="border-b border-gray-300 px-4 py-2 text-center">
                  Device
                </th>
                {statusFilter === 1 && (
                  <th className="border-b border-gray-300 px-4 py-2 text-center">
                    Action
                  </th>
                )}
              </tr>
            </thead>

            <tbody>
              {transactions.allTransaction?.map((transaction) => (
                <tr key={transaction._id} className="hover:bg-gray-50">
                  <td className="p-2 border-b border-gray-300 text-center">
                    <div className="flex items-center justify-center">
                      <div className="flex justify-center">
                        {transaction.userId?.profilePhoto ? (
                          <img
                            src={transaction.userId.profilePhoto}
                            alt="profile pic"
                            className="w-10 h-10 rounded-full"
                          />
                        ) : (
                          <DummyImage />
                        )}
                      </div>
                      <div className="flex flex-col items-center">
                        <div>
                          {transaction.userId?.firstName}{" "}
                          {transaction.userId?.lastName}
                        </div>
                        <div>{transaction.userId?.phoneNumber}</div>
                      </div>
                    </div>
                  </td>
                  <td className="p-2 border-b border-gray-300 text-center">
                    ${transaction.amount}
                  </td>
                  <td className="p-2 border-b border-gray-300 text-center">
                    {transaction.status === 1 ? "Pending" : "Paid"}
                  </td>
                  <td className="p-2 border-b border-gray-300 text-center">
                    {new Date(transaction.createdAt).toLocaleDateString()}
                  </td>
                  <td className="p-2 border-b border-gray-300 text-center">
                    <div className="flex flex-col items-left">
                      {transaction.accountDetails.map((item) => {
                        return (
                          <div className="bg-gray-200 p-2 rounded text-nowrap flex flex-col justify-start text-left">
                            <div key={item._id}>
                              <span className="font-bold">Account Title:</span>{" "}
                              {item.title}
                            </div>
                            <div key={item._id}>
                              <span className="font-bold">Account Number:</span>{" "}
                              {item.accountNumber}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </td>
                  <td>
                    {/* device     "deviceInfoMake": "string",
                "deviceInfoModel": "string", */}
                    <div className="flex flex-col items-left">
                      <div
                        className="bg-gray-200 p-2 rounded text-nowrap flex flex-col justify
                  _start text-left"
                      >
                        <div key={transaction.deviceInfoMake}>
                          <span className="font-bold">Make:</span>{" "}
                          {transaction.deviceInfoMake}
                        </div>
                        <div key={transaction.deviceInfoModel}>
                          <span className="font-bold">Model:</span>{" "}
                          {transaction.deviceInfoModel}
                        </div>
                      </div>
                    </div>
                  </td>
                  {transaction.status === 1 && (
                    <td className="p-2 border-b border-gray-300 text-center">
                      <button
                        onClick={() =>
                          handlePayTransaction(
                            transaction.userId._id,
                            transaction._id
                          )
                        }
                        className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                      >
                        Pay
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-gray-500 m-auto flex justify-center">
            <Loader />
          </p>
        )}
      </div>

      {/* No Data Message */}
      {!loading && transactions.allTransaction?.length === 0 && (
        <p className="text-gray-500 mt-4 text-center">No transactions found.</p>
      )}
      <SimplePagination
        totalPages={transactions?.paginationInfo?.totalPages || 1}
        currentPage={page}
        onPageChange={setPage}
        limit={limit}
        onLimitChange={(newLimit) => setLimit(newLimit)}
        totalItems={transactions?.paginationInfo?.totalItems || 0}
      />
    </Wrapper>
  );
};

export default WalletAdminPage;
